var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect } from "react";
import { useApi } from "@context/api";
import { useConfig } from "@context/config";
import { useLazyFetch } from "./";
var hasAvailableTimeEntry = function (timeEntries) {
    for (var _i = 0, timeEntries_1 = timeEntries; _i < timeEntries_1.length; _i++) {
        var available = timeEntries_1[_i].available;
        if (available)
            return true;
    }
    return false;
};
var markAvailableLocations = function (locations) {
    var _locations = [];
    for (var _i = 0, locations_1 = locations; _i < locations_1.length; _i++) {
        var location_1 = locations_1[_i];
        var slots = [];
        var available = false;
        for (var _a = 0, _b = location_1.slots; _a < _b.length; _a++) {
            var slot = _b[_a];
            var timeEntryAvailable = hasAvailableTimeEntry(slot.timeEntries);
            slots.push(__assign({ available: timeEntryAvailable }, slot));
            available = available || timeEntryAvailable;
        }
        _locations.push(__assign(__assign({}, location_1), { available: available,
            slots: slots }));
    }
    return _locations;
};
export var useDeliveryTypes = function () {
    var _a = useConfig(), shopifyProductId = _a.shopifyProductId, country = _a.country;
    var api = useApi().api;
    var deliveryTypePost = function () {
        return api.deliveryTypePost({ typePayload: { shopifyProductId: shopifyProductId, country: country } });
    };
    var _b = useLazyFetch(deliveryTypePost, {
        loading: true,
    }), getDeliveryTypes = _b[0], state = _b[1];
    useEffect(function () {
        getDeliveryTypes();
    }, []);
    return state;
};
export var useDeliveryPickup = function () {
    var _a = useConfig(), shopifyProductId = _a.shopifyProductId, country = _a.country;
    var api = useApi().api;
    var deliveryPickup = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
        var currentPosition, response;
        var coords = _a.coords, payload = __rest(_a, ["coords"]);
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    currentPosition = {};
                    if (coords) {
                        currentPosition["lat"] = coords.latitude;
                        currentPosition["lng"] = coords.longitude;
                    }
                    return [4 /*yield*/, api.deliveryPickupPost({
                            pickupPayload: __assign(__assign({ shopifyProductId: shopifyProductId,
                                country: country }, payload), currentPosition),
                        })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, markAvailableLocations(response)];
            }
        });
    }); };
    var response = useLazyFetch(deliveryPickup);
    return response;
};
export var useDeliveryDoorstep = function () {
    var _a = useConfig(), shopifyProductId = _a.shopifyProductId, country = _a.country;
    var api = useApi().api;
    var deliveryDoorstep = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.deliveryDoorstepPost({
                        doorstepPayload: __assign(__assign({}, payload), { shopifyProductId: shopifyProductId, country: country }),
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, markAvailableLocations(response)];
            }
        });
    }); };
    return useLazyFetch(deliveryDoorstep);
};
export var useAsyncDeliveryDoorstep = function () {
    var _a = useConfig(), shopifyProductId = _a.shopifyProductId, country = _a.country;
    var api = useApi().api;
    var asyncDeliveryDoorstep = function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.deliveryDoorstepPost({
                        doorstepPayload: __assign(__assign({}, payload), { shopifyProductId: shopifyProductId, country: country }),
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, markAvailableLocations(response)];
            }
        });
    }); };
    return asyncDeliveryDoorstep;
};
